import { useState, useEffect, useRef } from 'react';
import './App.css';

// Импорт секций
import Hero from './sections/Hero';
import About from './sections/About';
import SatbayevSpirit from './sections/SatbayevSpirit';
import BooksSection from './sections/BooksSection';
import WarSection from './sections/WarSection';
import HalykSection from './sections/HalykSection';
import CommentsSection from './sections/CommentsSection';
import StampsSection from './sections/StampsSection';

// Импорт глобальных компонентов
import BurgerMenu from './components/BurgerMenu';
import { LanguageSwitcher } from './components/LanguageSwitcher';

const SECTIONS = [
  { id: 'hero', Component: Hero },
  { id: 'about', Component: About },
  { id: 'spirit', Component: SatbayevSpirit },
  { id: 'books', Component: BooksSection },
  { id: 'war', Component: WarSection },
  { id: 'halyk', Component: HalykSection },
  { id: 'comments', Component: CommentsSection },
  { id: 'stamps', Component: StampsSection },
];

function App() {
  const [current, setCurrent] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isScrolling = useRef(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1280);
  const totalSections = SECTIONS.length;

  // ОБНОВЛЕННАЯ ФУНКЦИЯ СКРОЛЛА
  const scrollToSection = (index: number) => {
    setCurrent(index); // Обновляем индекс для точек и десктоп-анимации

    if (!isDesktop) {
      // На мобилках ищем элемент по ID и плавно скроллим к нему
      const sectionId = SECTIONS[index].id;
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 1280);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (!isDesktop) return;

    const handleWheel = (e: WheelEvent) => {
      if (isMenuOpen) return; 
      if (e.cancelable) e.preventDefault();
      if (isScrolling.current || Math.abs(e.deltaY) < 25) return;

      if (e.deltaY > 0) {
        if (current < totalSections - 1) {
          lock();
          setCurrent(current + 1);
        }
      } else if (e.deltaY < 0) {
        if (current > 0) {
          lock();
          setCurrent(current - 1);
        }
      }
    };

    const lock = () => {
      isScrolling.current = true;
      setTimeout(() => { isScrolling.current = false; }, 1200); 
    };

    window.addEventListener('wheel', handleWheel, { passive: false });
    return () => window.removeEventListener('wheel', handleWheel);
  }, [isDesktop, totalSections, isMenuOpen, current]); // Добавлен current в зависимости

  return (
    <div className={isDesktop ? "window-container" : "mobile-layout"}>
      
      <BurgerMenu 
        sections={SECTIONS} 
        current={current} 
        scrollToSection={scrollToSection} // Передаем нашу новую функцию
        isOpen={isMenuOpen}
        setIsOpen={setIsMenuOpen}
      />
      <LanguageSwitcher />

      {isDesktop ? (
        <>
          <div 
            className="viewport" 
            style={{ transform: `translateY(-${current * 100}vh)` }}
          >
            {SECTIONS.map(({ id, Component }, i) => (
              <div key={id} id={id} style={{ height: '100vh', width: '100%' }}>
                <Component isActive={current === i} />
              </div>
            ))}
          </div>

          <div className="dots-container">
            <div className="dots">
              {SECTIONS.map((_, i) => (
                <div 
                  key={i} 
                  className={`dot ${current === i ? 'active' : ''}`} 
                  onClick={() => scrollToSection(i)} // Тоже используем scrollToSection
                />
              ))}
            </div>
          </div>
        </>
      ) : (
        // МОБИЛЬНАЯ ВЕРСТКА: Добавляем id каждому блоку
        SECTIONS.map(({ id, Component }) => (
          <div key={id} id={id} className="mobile-section">
            <Component isActive={true} />
          </div>
        ))
      )}
    </div>
  );
}

export default App;